import React, {ReactNode} from 'react';
import DevSidebar from '../DevSidebar';
import DevTopbar from '../DevTopbar';
import './styles.css';

type Props = {
  +children: ReactNode,
  +merchant_id: number,
  +project_id: number
};

const DevLayout = ({merchant_id, project_id, children}: Props) => (
  <div className="dev-layout">
    <DevTopbar />
    <div className="dev-layout__sidebar-main">
      <DevSidebar merchant_id={merchant_id} project_id={project_id} />
      <div className="dev-layout__main">
        <div className="dev-layout__content">{children}</div>
      </div>
    </div>
  </div>
);

export default DevLayout;
